var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconTreeStand = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#1A202C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.897 10.03-.591-3.459a1.479 1.479 0 0 0-1.453-1.285 1.491 1.491 0 0 0-1.466 1.723L12.43 13c.094.721.7 1.267 1.427 1.286H18.6a1.504 1.504 0 0 0 1.543-1.505A1.491 1.491 0 0 0 18.6 11.29h-2.224a1.504 1.504 0 0 1-1.479-1.26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.143 17.179H9.857V4H6v18h3.857v-2.893h10.286z"
  })))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconTreeStand, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-tree-stand.2095abb8.svg";
export { ForwardRef as ReactComponent };